export default "__VITE_ASSET__Be6EnvSw__"